// deno-lint-ignore-file
const UriTemplate = /^(?:(?:[^\x00-\x20"'<>%\\^`{|}]|%[0-9a-f]{2})|\{[+#./;?&=,!@|]?(?:[a-z0-9_]|%[0-9a-f]{2})+(?::[1-9][0-9]{0,3}|\*)?(?:,(?:[a-z0-9_]|%[0-9a-f]{2})+(?::[1-9][0-9]{0,3}|\*)?)*\})*$/i;
/**
 * Returns true if the value is a uri template
 * @specification
 * @source ajv-formats
 */
export function IsUriTemplate(value) {
    return UriTemplate.test(value);
}
